import { createApi } from '@reduxjs/toolkit/query/react';
import { GraphQLClient } from 'graphql-request';
import { elevioBaseQuery } from 'components/conversation/components/integrations/elevio/src/utils/apis/graphql/baseQuery';
import { elevioUrls, getBackendDomain, resolveElevioUrlByEnvironment, } from '../../../../utils/apis';
import { articleQuery, kcsSettingsQuery, resolutionSearchArticlesQuery, searchArticlesQuery, suggestionsByTagQuery, suggestionsQuery, userSettingsQuery, } from './grappa.queries';
const backendDomain = getBackendDomain();
const grappaUrl = resolveElevioUrlByEnvironment({
    production: elevioUrls.production.grappa,
    staging: elevioUrls.staging.grappa,
}, backendDomain);
const grappaClient = new GraphQLClient(grappaUrl);
export const grappaApi = createApi({
    baseQuery: elevioBaseQuery(grappaClient),
    endpoints: (builder) => ({
        searchArticles: builder.query({
            query: (variables) => ({
                document: searchArticlesQuery,
                variables,
            }),
        }),
        article: builder.query({
            query: (variables) => ({
                document: articleQuery,
                variables,
            }),
        }),
        suggestions: builder.query({
            query: (variables) => ({
                document: suggestionsQuery,
                variables,
            }),
        }),
        suggestionsByTags: builder.query({
            query: (variables) => ({
                document: suggestionsByTagQuery,
                variables,
            }),
        }),
        kcsSettings: builder.query({
            query: (variables) => ({
                document: kcsSettingsQuery,
                variables,
            }),
        }),
        userSettings: builder.query({
            query: (variables) => ({
                document: userSettingsQuery,
                variables,
            }),
        }),
        resolutionSearchArticles: builder.query({
            query: (variables) => ({
                document: resolutionSearchArticlesQuery,
                variables,
            }),
        }),
    }),
    reducerPath: 'elevioGrappaApi',
});
